<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">

          <div v-if="!isGeneralLoading && form.Modulos.length === 0">
            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{msgEmptyModules}}</label>
          </div>

          <base-collapsible-form 
            v-for="(cabecera, index) in form.Modulos"
            :key="index"
            :ref="'baseCollapsibleModules'+index" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{cabecera.Descripcion}}</h2>
            </template>
            <template slot="content">

              <div class="mb-4" 
                v-for="modulo in cabecera.Modulos"
                :key="modulo.idModulo">
                <label :for="'switch-modulo-' + modulo.idModulo" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{modulo.Descripcion}}
                  <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                </label>
                <div class="flex flex-col md:flex-row mt-2">
                  <el-switch 
                    :id="'switch-modulo-' + modulo.idModulo"
                    :aria-label="modulo.Descripcion"
                    class="switch-text break-normal both-switch" 
                    v-model="modulo.Contratado" 
                    :disabled="!modulo.Modificable"
                    :active-text="$t('app.active')" 
                    />
                  <label class="text-sm font-semibold text-secondary-600 block mb-1 ml-0 md:ml-4">{{modulo.FechaCambioEstado}}</label>
                </div>
              </div>

            </template>
          </base-collapsible-form>

        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive 
            mode="primary" 
            :text="$t('app.save')" 
            icon="save" 
            @click="submitForm()" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import { getClient } from '@/services/clients/getClient'
import { getModulosCliente } from '@/services/clients/getModulosCliente'
import { updateModulosCliente } from '@/services/clients/updateModulosCliente'
import { i18n } from '@/i18n'
import moment from 'moment'

export default {
  /* eslint-disable camelcase */
  name: 'modules-client-detail',
  components: {
    DetailLayoutFullWidth,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('clients.modules'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/clients/details'
      },
      msgEmptyModules: this.$i18n.t('clients.modules_empty'),
      msgEmptyDate: this.$i18n.t('clients.modules_empty_date'),
      form: {
        Modulos: [],
      },
      rules: {}
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    disableTipoLibre () {
      return (this.role === 'SuperAdminDistribuidor' || this.role === 'AdminDistribuidor') &&
       this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 1
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    const clientId = this.$route.params.id
    const breadcrumbs = []
    breadcrumbs.push({
      path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
      name: this.$i18n.t('app.configurations')
    })
    breadcrumbs.push({
      path: 'configurations/clients',
      name: this.$i18n.t('app.clients')
    })
    if (clientId !== -1) {
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(clientId)
        breadcrumbs.push({ path: '', name: cliente.empresa.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.empresa.Nombre)
      }
    }
    this.header.breadcrumb = breadcrumbs

    const data = await this.downloadData(clientId)
    this.setData(data.Cabeceras)
  },
  mounted () {
    this.resetControlFormChanges()
  },
  methods: {
    formatDate: function (strDate) {
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [Código de error: ' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    submitForm: async function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const modulos = []
        this.form.Modulos.forEach(cabecera => {
          cabecera.Modulos.forEach(modulo => {
            modulos.push({
              idModulo: modulo.idModulo,
              Activo: modulo.Contratado,
            })
          })
        })
        const payload = {
          idCliente: this.$route.params.id,
          Modulos: modulos,
        }
        const response = await updateModulosCliente(null, payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Datos actualizados correctamente', 'success')
          const data = await this.downloadData(this.$route.params.id)
          this.setData(data.Modulos)
          this.resetControlFormChanges()
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/clients/details', params: this.$route.params.id })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const data = await getModulosCliente({ idCliente: id })
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          return data
        }
        return data
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setData: function (data) {
      if (data) {
        const cabeceras = data
        cabeceras.forEach(cabecera => {
          cabecera.Modulos.forEach(x => {
            if (x.FechaCambioEstado) x.FechaCambioEstado = this.formatDate(x.FechaCambioEstado)
            else x.FechaCambioEstado = this.msgEmptyDate
          })
        })
        this.form.Modulos = cabeceras
      }
      this.resetControlFormChanges()
    },
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
